module.exports = __webpack_public_path__ + "static/media/shtrips3.96b4c68e.jpg";